import '../../App.scss'
import React, { Component } from 'react'
import Artifact from './Artifact';


export default class MuseumList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            previous: '',
            data: {
                items: [{
                    content: '',
                    title: 'loading...',
                    blog:
                    {
                        id: 'loading'
                    }
                }
                ]
            }
        };
    }
    async componentDidMount() {
        await fetch('https://www.googleapis.com/blogger/v3/blogs/2866489321388664435/posts?key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ')
        // await fetch('https://www.googleapis.com/blogger/v3/blogs/3917238484875234696/posts?key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ')
            .then(response => response.json())
            .then(data => this.setState({ data: data }));
        console.log(this.state.data.items)
    }

    search = async () => {
        let search = this.state.search
        await fetch(`https://www.googleapis.com/blogger/v3/blogs/2866489321388664435/posts/search?q=${search}&key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ`)
            .then(response => response.json())
            .then(results => {
                results.items ? this.setState({ data: results, totalResults: results.items.length, previous: search}) : alert('Sorry we were unable to find any results that matched.')
            });
    }
    render() {
        const Input = () => {
            const handleKeyDown = (event) => {
              if (event.key === 'Enter') {
                this.search()
              }
            }
          
            return <input onChange={e => this.setState({ search: e.target.value })} type="text" onKeyDown={handleKeyDown} />
          }
        return (
            <div>
                <div className="TopBar">
                    <div className="TopDivider">
                        <h1>AHRF Museum  </h1>
                        <div className="SearchBar">
                            {Input()}
                            <div onClick={()=>this.search()}className="Register">Search</div>
                            <div className="AboutTop">
                                <p>The AHRF online museum is a display of artifacts and other interesting finds not known to the public at large. AHRF seeks to make this information available while also preserving and protecting historical sites/artifacts.</p>
                            </div>
                        </div>
                            <p>{this.state.totalResults ? this.state.totalResults + ' result(s) found for ' + "'" + this.state.previous + "'" : ''}</p>
                    </div>
                </div>
                <div className="MuseumList">

                    {this.state.data.items.map((info, index) => (
                        <Artifact
                            info={info} />
                    ))}

                </div>
            </div>
        );
    }
}
